import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import React from 'react';

export interface TextareaProps extends Omit<TextFieldProps, 'variant'> {
  legacy?: boolean;
}

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'legacy',
})<{ legacy?: boolean }>(({ theme, legacy }) => ({
  ...(legacy && {
    '& textarea': {
      maxHeight: theme.spacing(25),
      minHeight: theme.spacing(3.75),
      padding: '0 !important',
      marginTop: theme.spacing(1),
    },
    '& .MuiOutlinedInput-root': {
      fontSize: theme.spacing(1.75),
      padding: `${theme.spacing(1.25)} !important`,
    },
  }),
}));

const Textarea: React.FC<TextareaProps> = ({ legacy, ...props }) => (
  <StyledTextField
    variant="outlined"
    multiline
    legacy={legacy}
    {...props}
    {...(props.label && { InputLabelProps: { shrink: true } })}
  />
);

export default Textarea;
